import { FC } from 'react';
import { CheckboxProps } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

import { Checkbox as AntCheckbox } from '../../uikit/Checkbox';

export const Checkbox: FC<CheckboxProps> = ({ ...props }) => {
  return <StyledCheckbox {...props} checked={props.checked ?? false} />;
};

const StyledCheckbox = styled(AntCheckbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${COLORS.systemSky200};
    border-color: ${COLORS.systemSky200};
  }

  .ant-checkbox-checked::after {
    border-color: ${COLORS.systemSky200};
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${COLORS.systemSky200};
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: ${COLORS.systemLight300};
    border-color: ${COLORS.systemDark100};
    &::after {
      border-color: ${COLORS.systemDark100};
    }
  }
`;
